var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v(_vm._s(_vm.notification.cause.entityName))]),_vm._v("\n  "+_vm._s(_vm.$t(this.messageBody))+"\n  "),_c('i',[_vm._v(_vm._s(_vm.notification.details.documentTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }